import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "pa-2 d-inline-block text-right text-caption w-100" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"#00ff00"}
}
const _hoisted_3 = {
  key: 1,
  style: {"color":"#00beff"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (!_ctx.isInErrorState && _ctx.currentTenantSchema)
    ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
        key: 0,
        theme: "dark",
        order: 1,
        modelValue: _ctx.navDrawerOpen,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.navDrawerOpen) = $event)),
        id: "main-nav"
      }, {
        append: _withCtx(() => [
          _createElementVNode("i", _hoisted_1, [
            _createVNode(_component_v_tooltip, {
              location: "top",
              "content-class": "ben-tooltip--clean tooltip-max-width",
              "open-on-click": ""
            }, {
              activator: _withCtx(({ props }) => [
                _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
                  _createTextVNode(_toDisplayString(_ctx.version) + " ", 1),
                  (_ctx.user?.testAccount)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.validating)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_2, " -green "))
                          : (_openBlock(), _createElementBlock("span", _hoisted_3, " -blue "))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_icon, {
                    size: "small",
                    style: {"color":"white"}
                  }, {
                    default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                      _createTextVNode("mdi-information-outline", -1)
                    ]))]),
                    _: 1
                  })
                ], 16)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.buildVersion), 1)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            class: "pl-4",
            justify: "end",
            style: {"height":"65px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                md: "8",
                "align-self": "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    src: _ctx.bensisLogo,
                    "max-width": "100",
                    alt: "Bensis Logo",
                    "aspect-ratio": "2.8"
                  }, null, 8, ["src"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                md: "4",
                "align-self": "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    size: "small",
                    class: "mt-1",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.close()), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createTextVNode("mdi-menu", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_list, {
            class: "pt-0",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_divider, { class: "mb-4" }),
              (_ctx.currentTenantSchema !== null)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.authorizer.authorize(_ctx.roleLevel.Read, _ctx.module.AssetManagement, _ctx.user, _ctx.currentTenantSchema))
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 0,
                          to: '/dashboard/' + _ctx.currentTenantSchema
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "nav-list-item" }, {
                              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createTextVNode("Dashboard", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true),
                    (_ctx.authorizer.authorize(_ctx.roleLevel.Read, _ctx.module.AssetManagement, _ctx.user, _ctx.currentTenantSchema) && _ctx.currentTenant.tenantOptions.showAssetMap)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 1,
                          to: '/asset-map/' + _ctx.currentTenantSchema
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "nav-list-item" }, {
                              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createTextVNode("Asset Map", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true),
                    (_ctx.authorizer.authorizeOneOf(_ctx.roleLevel.Read, [_ctx.module.AssetManagement, _ctx.module.AllocationsFormulas, _ctx.module.Production, _ctx.module.Measurements], _ctx.user, _ctx.currentTenantSchema))
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 2,
                          to: '/jobs/' + _ctx.currentTenantSchema
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "nav-list-item" }, {
                              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                _createTextVNode("Jobs", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true),
                    (_ctx.authorizer.authorize(_ctx.roleLevel.Read, _ctx.module.StateReports, _ctx.user, _ctx.currentTenantSchema))
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 3,
                          to: '/reports/' + _ctx.currentTenantSchema
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "nav-list-item" }, {
                              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                _createTextVNode("Reports", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true),
                    (_ctx.authorizer.authorize(_ctx.roleLevel.Read, _ctx.module.FieldObservations, _ctx.user, _ctx.currentTenantSchema))
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 4,
                          to: '/field-observations/' + _ctx.currentTenantSchema
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "nav-list-item" }, {
                              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                _createTextVNode("Field Observations", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true),
                    (_ctx.authorizer.authorize(_ctx.roleLevel.Read, _ctx.module.AssetManagement, _ctx.user, _ctx.currentTenantSchema))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                          _createVNode(_component_v_list_subheader, { class: "pt-4 pb-1 pl-4 nav-subheading" }, {
                            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                              _createTextVNode("INFRASTRUCTURE", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item, {
                            to: '/wells/' + _ctx.currentTenantSchema
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, { class: "nav-list-item" }, {
                                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                  _createTextVNode("Wells", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["to"]),
                          _createVNode(_component_v_list_item, {
                            to: '/meters/' + _ctx.currentTenantSchema
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, { class: "nav-list-item" }, {
                                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                  _createTextVNode("Meters", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["to"]),
                          _createVNode(_component_v_list_item, {
                            to: '/fields/' + _ctx.currentTenantSchema
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, { class: "nav-list-item" }, {
                                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                  _createTextVNode("Fields", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["to"]),
                          _createVNode(_component_v_list_item, {
                            to: '/facilities/' + _ctx.currentTenantSchema
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, { class: "nav-list-item" }, {
                                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                  _createTextVNode("Facilities", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["to"]),
                          _createVNode(_component_v_list_item, {
                            to: '/pipelines/' + _ctx.currentTenantSchema
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, { class: "nav-list-item" }, {
                                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                  _createTextVNode("Pipelines", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.authorizer.authorizeOneOf(_ctx.roleLevel.Read, [_ctx.module.AssetManagement, _ctx.module.Production, _ctx.module.Measurements, _ctx.module.AllocationsFormulas], _ctx.user, _ctx.currentTenantSchema))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                          _createVNode(_component_v_list_subheader, { class: "pt-4 pb-1 pl-4 nav-subheading" }, {
                            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                              _createTextVNode("PERFORMANCE", -1)
                            ]))]),
                            _: 1
                          }),
                          (_ctx.authorizer.authorize(_ctx.roleLevel.Read, _ctx.module.AssetManagement, _ctx.user, _ctx.currentTenantSchema))
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 0,
                                to: '/reporting-units/' + _ctx.currentTenantSchema
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { class: "nav-list-item" }, {
                                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                      _createTextVNode("Reporting Units", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : _createCommentVNode("", true),
                          (_ctx.authorizer.authorize(_ctx.roleLevel.Read, _ctx.module.Production, _ctx.user, _ctx.currentTenantSchema))
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 1,
                                to: '/production/' + _ctx.currentTenantSchema
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { class: "nav-list-item" }, {
                                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                      _createTextVNode("Production", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : _createCommentVNode("", true),
                          (_ctx.authorizer.authorize(_ctx.roleLevel.Read, _ctx.module.Measurements, _ctx.user, _ctx.currentTenantSchema))
                            ? (_openBlock(), _createBlock(_component_v_list_group, {
                                key: 2,
                                value: "Measurements"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { class: "nav-list-item" }, {
                                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                          _createTextVNode("Measurement", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 16)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item, {
                                    to: '/pressure-readings/' + _ctx.currentTenantSchema
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { class: "ml-2 text-body-2" }, {
                                        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                          _createTextVNode("Pressure Readings", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["to"]),
                                  _createVNode(_component_v_list_item, {
                                    to: '/gas-analysis/' + _ctx.currentTenantSchema
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { class: "ml-2 text-body-2" }, {
                                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                          _createTextVNode("Gas Analysis", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["to"]),
                                  _createVNode(_component_v_list_item, {
                                    to: '/water-analysis/' + _ctx.currentTenantSchema
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { class: "ml-2 text-body-2" }, {
                                        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                          _createTextVNode("Water Analysis", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["to"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.authorizer.authorize(_ctx.roleLevel.Read, _ctx.module.AllocationsFormulas, _ctx.user, _ctx.currentTenantSchema))
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 3,
                                to: '/allocations/' + _ctx.currentTenantSchema
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { class: "nav-list-item" }, {
                                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                      _createTextVNode("Allocations", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_divider)
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_v_list_subheader, { class: "pt-4 pb-1 pl-4 nav-subheading" }, {
                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                  _createTextVNode("SETTINGS", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_list_item, { to: "/account/" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, { class: "nav-list-item" }, {
                    default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                      _createTextVNode("My Account", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.authorizer.authorize(_ctx.roleLevel.Read, _ctx.module.CompanyAdmin, _ctx.user, _ctx.currentTenantSchema))
                ? (_openBlock(), _createBlock(_component_v_list_group, {
                    key: 1,
                    value: "Company Administration"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "nav-list-item" }, {
                            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                              _createTextVNode("Company Administration", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 16)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        to: '/company-information/' + _ctx.currentTenantSchema
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "ml-2 text-body-2" }, {
                            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                              _createTextVNode("Company Information", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _createVNode(_component_v_list_item, {
                        to: '/units-and-pressure-base/' + _ctx.currentTenantSchema
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "ml-2 text-body-2" }, {
                            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                              _createTextVNode("Units and Pressure Base", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _createVNode(_component_v_list_item, {
                        to: '/organizations/' + _ctx.currentTenantSchema
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "ml-2 text-body-2" }, {
                            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                              _createTextVNode("Organizations", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _createVNode(_component_v_list_item, {
                        to: '/lookup-values/' + _ctx.currentTenantSchema
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "ml-2 text-body-2" }, {
                            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                              _createTextVNode("Lookup Values", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _createVNode(_component_v_list_item, {
                        to: '/personnel/' + _ctx.currentTenantSchema
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "ml-2 text-body-2" }, {
                            default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                              _createTextVNode("Personnel", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.authorizer.authorize(_ctx.roleLevel.SystemAdmin, null, _ctx.user, null))
                ? (_openBlock(), _createBlock(_component_v_list_item, {
                    key: 2,
                    to: "/system-administration/"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, { class: "nav-list-item" }, {
                        default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                          _createTextVNode("System Administration", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}